import {
  CruiseLiteModel,
  CruiseModel,
  getCruiseKey,
  getCruisesKey,
  useGetCruise,
  useGetCruises,
} from 'api-hooks/cruise';
import { Option } from 'baseui/select';
import { NavigationRoutes } from 'common/constants';
import { ModelTransformer } from 'common/helpers/common';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useNavigation from 'hooks/use-navigation';

import { ColumnDataType } from '../type';

export function cruiseTransformer(item: CruiseLiteModel | CruiseModel): Option {
  return {
    id: item.id,
    label: item.name,
    extra: item,
  };
}

export default function useCruiseColumn() {
  const permission = useGetCrudPermission('cruises');
  const { navigate } = useNavigation();
  const cruiseColumn = {
    dataType: ColumnDataType.select,
    useListQueryHook: useGetCruises,
    useDetailLazyQueryHook: useGetCruise,
    listKeyFunction: getCruisesKey,
    detailKeyFunction: getCruiseKey,
    getMemoizedListVariables: (page, q) => ({
      params: {
        q,
        page,
      },
    }),
    getMemoizedDetailVariables: (value: string) => ({
      id: value,
    }),
    listTransformer(result) {
      return result.data.map((v) => {
        const data = ModelTransformer(v, CruiseLiteModel);
        return cruiseTransformer(data);
      });
    },
    detailTransformer(result) {
      const data = ModelTransformer(result.data, CruiseModel);
      return cruiseTransformer(data);
    },
    paginationTransformer(result) {
      return result.meta;
    },
    renderCreate: permission.create,
    onClickCreate: () => {
      navigate(NavigationRoutes.CruisesCreate);
    },
  };

  return cruiseColumn;
}
